package com.hyperether.goodjob.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SuperAdmin(
    @SerialName("_id") var _id: String? = null,
    @SerialName("fullName") var fullName: String? = null,
    @SerialName("email") var email: String? = null,
    @SerialName("role") var role: String? = null,
    @SerialName("type") var type: String? = null,
    @SerialName("workspaceId") var workspaceId: String? = null,
)
